import Quill from 'quill';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Inline = Quill.import('blots/inline') as any;

const TOOLTIP_SEP = '\u001E'; // Record separator - não aparece em texto normal

export const DATA_LINK_EMPTY_CLASS = 'ql-data-link--empty';

let resolveLinkFilled: (tag: string) => boolean = () => true;

export function setDataLinkFilledResolver(filled: (tag: string) => boolean): void {
    resolveLinkFilled = filled;
}

export function encodeDataLinkFormat(normalized: string, description?: string): string {
    return description ? `${normalized}${TOOLTIP_SEP}${description}` : normalized;
}

export function decodeDataLinkFormat(value: string): { normalized: string; description?: string } {
    const idx = value.indexOf(TOOLTIP_SEP);
    if (idx < 0) return { normalized: value };
    return { normalized: value.slice(0, idx), description: value.slice(idx + 1) };
}

function applyLinkFilledClass(node: HTMLElement, normalized: string): void {
    node.classList.toggle(DATA_LINK_EMPTY_CLASS, !resolveLinkFilled(normalized));
}

export function updateDataLinkValidityClasses(root: HTMLElement): void {
    root.querySelectorAll<HTMLElement>(`.${DataLinkBlot.className}[data-value]`).forEach(node => {
        const tag = node.getAttribute('data-value') ?? '';
        if (tag) applyLinkFilledClass(node, tag);
    });
}

/** Armazena descrição para tooltip customizado (ra-tooltip) */
export const DATA_LINK_DESC_ATTR = 'data-link-desc';

/**
 * Blot customizado para destacar links de dados ($COMPANY_NAME, etc.) no editor.
 * Usado apenas na renderização; o atributo é removido antes de salvar.
 */
class DataLinkBlot extends Inline {
    static blotName = 'dataLink';
    static tagName = 'span';
    static className = 'ql-data-link';

    static create(value: string) {
        const node = super.create() as HTMLSpanElement;
        const { normalized, description } = decodeDataLinkFormat(value ?? '');
        node.setAttribute('data-value', normalized);
        if (description) node.setAttribute(DATA_LINK_DESC_ATTR, description);
        node.classList.add(DataLinkBlot.className);
        applyLinkFilledClass(node, normalized);
        return node;
    }

    static formats(domNode: HTMLElement) {
        return domNode.getAttribute('data-value') ?? undefined;
    }

    format(name: string, value: string) {
        if (name === DataLinkBlot.blotName && value) {
            const { normalized, description } = decodeDataLinkFormat(value);
            const node = (this as any).domNode as HTMLElement;
            node.setAttribute('data-value', normalized);
            if (description) node.setAttribute(DATA_LINK_DESC_ATTR, description);
            else node.removeAttribute(DATA_LINK_DESC_ATTR);
            node.classList.add(DataLinkBlot.className);
            applyLinkFilledClass(node, normalized);
        } else {
            super.format(name, value);
        }
    }

    formats() {
        const value = ((this as any).domNode as HTMLElement).getAttribute('data-value');
        return value ? { [DataLinkBlot.blotName]: value } : {};
    }
}

export function registerLinkPlaceholderBlot(): void {
    try {
        Quill.register(DataLinkBlot);
    } catch {
        // Já registrado
    }
}

export const DATA_LINK_ATTR = 'dataLink';
